/**
 * Party characteristics Addresses section
 */
import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const AddressesState = {
  addresses: [],
  saveAddressesTriggered: false,
}

export const AddressesActions = {
  fetchAddresses: async ({ commit }, req) => {
    return axiosRequest.
      get(`/parties/${req.partyId}/addresses`).
      then(({ data }) => commit('setAddresses', data.addresses)).
      catch(handleError)
  },
  createAddress ({ commit }, req) {
    return axiosRequest.
      post(`/parties/${req.party_id}/addresses`, { address: req }).
      then(({ data }) => commit('setAddresses', data.addresses)).
      catch(handleError)
  },
  saveAddress ({ commit }, req) {
    return axiosRequest.
      patch(`/parties/${req.party_id}/addresses/${req.id}`, { address: req }).
      then(({ data }) => commit('setAddresses', data.addresses)).
      catch(handleError)
  },
}

export const AddressesMutations = {
  setAddresses: (state, payload) => { state.addresses = payload },
  setAddress: (state, payload) => { if (payload.index !== -1) Vue.set(state.addresses, payload.index, payload.data) },
  setAddressSaveTriggered: (state, payload) => { state.saveAddressesTriggered = payload },
}

export const AddressesGetters = {
  getAddresses: state => state.addresses,
  getSaveAddressTriggered: state => state.saveAddressesTriggered,
}
